module.exports = __webpack_public_path__ + "img/high.bc263815.png";